import React from 'react'

export const Content: React.FC<{html: string}> = ({html}) => {
  return <div dangerouslySetInnerHTML={{__html: html}} />
}